export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_SORT_ORDER = 'desc' as const;
export const DEFAULT_SORT_BY = 'created_at';

export interface IPaginationParams {
	offset?: number;
	limit?: number;
	sortBy?: string;
	sortOrder?: 'asc' | 'desc';
	filters?: Record<string, any>;
}

export interface IPaginationQueryParams {
	offset?: number;
	limit: number;
	sortBy: string;
	sortOrder: 'asc' | 'desc';
	filters?: string;
}

export interface IPaginationDefaults {
	sortBy?: string;
	limit?: number;
}
